import { ControlType } from './enums';

export function controlTypeFromMinutes(minutes) {
    const min = Number(minutes);
    if (isNaN(min)) return null;
    if (min < 3) return ControlType.BULLET;
    if (min < 6) return ControlType.BLITZ;
    if (min < 45) return ControlType.RAPID;
    return ControlType.CLASSIC;
}
